<template>
  <div class="ma-2 ml-3 site_content">
    <div class="info_notice">
      본 설문은 축산물 품질평가원에서 제공하는 자료를 토대로 산정되는 결과이며,<br/>
      <span style="font-weight:800;">농가에서 제공하는 정보의 정확성에 따라 인증 평가 및 지원 자격 여부가 결정</span> 되므로, 
      정확한 내용을 기입해 주시기 바랍니다.<br/>
      부정확한 정보를 기재할 경우 평가 결과가 실제와 다르게 산출 될 수 있으며, 이에 따른 모든 책임은 신청자에게 있음을 유의해주시기 바랍니다.
    </div>
    

    <v-row justify="center">
      <v-checkbox v-model="checkbox" color="#005B96" class="checkbox" label="동의합니다."></v-checkbox>
    </v-row>

    <div class="eligibility_cotent" v-show="checkbox">
      <div class="title flex">
        <div class="line mr-2"></div>
        <div>지원 가능 조건</div>
      </div>

      <div class="eligibility_info mt-3">
        <div class="notice_info">
          ・ 농・식품 국가 인증 및 지정서 종류 7종 중 1개 이상 보유 시 지원 가능<br/>
          <div class="sub_info ml-5">
            <span>・ 유기 축산물</span>
            <span>・ 깨끗한 축산농장</span>
            <span>・ 환경친화 축산농장</span>
            <span>・ HACCP (축산물)</span>
            <Br/>
            <span>・ 무항생제 축산물</span>
            <span>・ 방목생태 축산농장</span>
            <span>・ 동물복지 축산농장</span>
          </div>

          <div style="font-size:13px;">
            - 유효기간 잔여일이 인증 및 지정 접수일로부터 신규 인증 및 지정 120일, 갱신 60일, 변경 30일 이상이어야 함. <br/>
            - 농식품 국가인증, 지정의 갱신 또는 유효기간 연장신청에 대한 증빙자료 제출 시 인정
          </div>
        </div>

        <div class="notice_info farm_info mt-2">
          <div class="flex vertical-center">
            <div class="farm_title">농장명</div>
            <div> 
              <comboFarm
                @fromFarm="farmInfo"
              />
            </div>
          </div>

          <div v-if="pig_ship !== null">
            <div class="flex vertical-center mt-3">
              <div class="farm_title">경영형태</div>
              <div class="info_content"> 
                {{ biz_type }}
              </div>
            </div>

            <div class="flex vertical-center mt-3">
              <div class="farm_title">출하실적</div>
              <div class="info_content"> 
                {{pig_ship}} 두
              </div>
            </div>
          </div>

          <div v-else>
            <div class="flex vertical-center mt-3">
              <div class="farm_title">경영형태</div>
              <div class="info_content"> 
                <v-select dense outlined 
                  v-model="biz_structure" 
                  ref="biz_structure" 
                  class="farm"
                  label=""
                  :items="['일관경영','번식경영1 (번식‣분만)','번식경영2 (번식‣분만‣새끼)','비육경영1 (새끼‣비육)','비육경영2 (비육)']"
                  item-text="name"
                  :menu-props="{ top: false, offsetY: true }"
                  return-object
                />
              </div>
            </div>
            <div class="flex vertical-center mt-3">
              <div class="farm_title">출하실적</div>
              <div class="info_content"> 
                <v-text-field dense outlined
                  class="textfield"
                  id="pig_cnt" 
                  ref="pig_cnt" 
                  label="" 
                  suffix="두" 
                  v-model="pig_cnt" 
                />
              </div>
            </div>
          </div>

          <div class="more_info">
            <v-icon size="12">mdi-information-outline</v-icon>
            지원요건 : 일관 농장 및 6개월 이내 출하실적 1800두 이상 농가
          </div>
        </div>
        
      </div>

      <v-row class="mt-3" justify="center">
        <v-dialog
          v-model="carbon_dialog"
          max-width="450" 
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="certify_btn" 
              style="color:white !important;" 
              v-bind="attrs"
              v-on="on"
              @click="lowcarbon()">
              지원 가능 여부 확인
            </v-btn>
          </template>

          <v-card class="dialog_content">
            지원 가능 조건이 충족되지 않아 지원이 불가능한 농장입니다. <br/>
            지원 가능 조건을 확인하세요.
            <v-row justify="end">
              <v-btn class="vertify_btn" style="color:white !important;" @click="clearData()">확인</v-btn>
            </v-row>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </div>
</template>

<script>
import Apis from '@/api/apis';
import comboFarm from "@/components/combo/farm.vue";
import dateUtil from "@/utils/custom/dateProperty.js";

export default ({
  name:"LowAvailable",
  components:{
    comboFarm,
  },
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res); 
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 
  },
  data(){
    return{
      checkbox : false,
      farmData: { company: {}, farm: {} },
      bizStatus: false,
      
      biz_structure:'',
      pig_cnt:'',

      biz_type:'',
      pig_ship:'',

      carbon_dialog:false,
    }
  },
  methods:{
    farmInfo(data){
      this.farmData = data;

      this.certifyInfo();
    },
    certifyInfo(){
      Apis.certifyLowCarbonBase({
        "farm_cd" : this.farmData.farm.code,
        "stand_date" : dateUtil.format(new Date(), "yyyy-MM-dd"),
        "month" : 6
        },(res) => {  
          if (res.result) {
            this.biz_type = res.data.type;
            this.pig_ship = res.data.ship;

            // console.log(res.data.farm)
          } 
        }).catch( (err) => {  // API 오류 처리
          console.log("certifyLowCarbonBase API 호출 오류",err)
          this.$store.commit("resMessage","certifyLowCarbonBase API 호출 오류");
        }
      ) 
    },
    checkData(){
      if (this.pig_ship !== null){
        if(this.biz_type !== '일관경영' || this.info_pig_cnt < 1800) {
          return true; 
        }
      }else{
        if(this.biz_structure !== '일관경영' || this.pig_cnt < 1800){
          return true;
        }
      }
      return false; 
    },
    clearData(){
      this.carbon_dialog = false;
      
      this.biz_structure = '';
      this.pig_cnt = '';
    },
    lowcarbon(){
      if (this.checkData()) {
        this.carbon_dialog = true; 
      } else {
        this.$router.push({
          name: "Lowcarbon",
          params: { 
            company: this.farmData.company,
            farm: this.farmData.farm,
          }
        });
      }
    }
  }
})
</script>

<style scoped lang=scss>
@import '../../style/base.scss';
.info_notice , .eligibility_info{
  margin: 0 auto;
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 25px;
  padding:20px;
  letter-spacing: -1px;
  max-width:850px;
}
.eligibility_cotent{
  margin: 0 auto;
  max-width:850px;
  margin-top:50px;
}
::v-deep .v-input--checkbox > .v-input__control > .v-input__slot{
  background-color: transparent !important;
}
.notice_info{
  border: 1px solid #DDDDDD;
  padding:10px 80px;
  border-radius: 15px;
}
.sub_info span{
  display:inline-block;
  width:150px !important;
}
.farm_info .farm_title{
  width:130px;
  font-weight:550;
  font-size:16px;
}
.info_content{
  width:270px;
}
::v-deep .certify_btn{

background: #005B96 !important;
box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
border-radius: 50px !important;

width:200px !important;
font-size:16px !important;
height:40px !important;
}
.vertify_btn{
  background-color: $main-color !important;
  margin-top:30px;
  border-radius: 20px;
  color: white !important;
}
.more_info{
  font-size:13px;
  text-align: center;
  margin-top:10px;
  color:#8d8d8d;
}
.dialog_content{
  
}
::v-deep .textfield {
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3); /* 그림자 효과 */
  height:48px;
  border-radius: 10px;
  width:230px;
}
::v-deep .textfield .v-input__slot{
  height:48px;
}
::v-deep .v-text-field__suffix{
  width:350px !important;
}
::v-deep .v-input__prepend-inner{
  display: none !important;
}
::v-deep .refresh_btn{
  display: none !important;
}
.dialog_content{
  padding:20px;
}
</style>